import React, {useState} from 'react';
import IconFullStar from '../../components/icon/IconFullStar';
import IconHalfStar from '../../components/icon/IconHalfStar';
import IconEmptyStar from '../../components/icon/IconEmptyStar';
import cn from 'classnames';

interface StarRatingProps {
  onChange: (value: number) => void;
  className?: string
}

export default function StarRating({onChange, className}: StarRatingProps) {
  const [rating, setRating] = useState<number | undefined>(undefined);
  const [hoverRating, setHoverRating] = useState<number | undefined>(rating);

  const onSlotHover = (slotValue: number) => {
    setHoverRating(slotValue);
  };

  const onSlotLeftHover = () => {
    setHoverRating(undefined);
  };

  const onSlotClick = (slotValue: number) => {
    setRating(slotValue);
    onChange(slotValue);
  };

  const activeRating = () => (hoverRating !== undefined ? hoverRating : rating);

  return (
    <div className={cn('flex flex-row cursor-pointer text-yellow', className)}>
      <StarSlot value={2} onHover={onSlotHover} onLeftHover={onSlotLeftHover} onClick={onSlotClick}
                rating={activeRating()}/>
      <StarSlot value={4} onHover={onSlotHover} onLeftHover={onSlotLeftHover} onClick={onSlotClick}
                rating={activeRating()}/>
      <StarSlot value={6} onHover={onSlotHover} onLeftHover={onSlotLeftHover} onClick={onSlotClick}
                rating={activeRating()}/>
      <StarSlot value={8} onHover={onSlotHover} onLeftHover={onSlotLeftHover} onClick={onSlotClick}
                rating={activeRating()}/>
      <StarSlot value={10} onHover={onSlotHover} onLeftHover={onSlotLeftHover} onClick={onSlotClick}
                rating={activeRating()}/>
    </div>
  );
}

type RatingSlotProps = {
  value: number
  rating?: number
  onHover: (value: number) => void
  onLeftHover: () => void
  onClick: (value: number) => void
}

function StarSlot({
                    value, rating, onHover, onLeftHover, onClick
                  }: RatingSlotProps) {
  const star = () => {
    if (rating !== undefined) {
      if (value <= rating) {
        return <IconFullStar/>;
      } else if (value === rating + 1) {
        return <IconHalfStar/>;
      }
      return <IconEmptyStar/>;
    }
    return <IconEmptyStar/>;
  };

  return (
    <div className="px-0.5" onPointerEnter={() => onHover(value)}
         onPointerLeave={() => onLeftHover()} onClick={() => onClick(value)}>
      {star()}
    </div>
  );
}
